import * as React from "react";

import { Router } from "react-router";

import Routes from "Routes";
import { Beforeunload } from "react-beforeunload";
import { TakeOffStore } from "./modules/takeOff/TakeOffStore";

const createBrowserHistory = require("history").createBrowserHistory;

class App extends React.Component {
  public render() {
    const history = createBrowserHistory();
    return (
      <Beforeunload
        onBeforeunload={() => {
          if (TakeOffStore.savingTakeOffItems.some((x) => x.isSaving)) {
            return "Ainda existem dados do TakeOffItems sendo salvos!";
          } else return;
        }}
      >
        <div id="APPID">
          <Router history={history}>
            <Routes />
          </Router>
        </div>
      </Beforeunload>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx